import * as React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgSearch = (
	{
		color,
		width = 20,
		height = 20
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.994 27.994">
		<g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1 1)">
			<path id="Tracé_167" data-name="Tracé 167" d="M27.237,15.869A11.369,11.369,0,1,1,15.869,4.5,11.369,11.369,0,0,1,27.237,15.869Z" transform="translate(-4.5 -4.5)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round"
			      strokeWidth="2" />
			<path id="Tracé_168" data-name="Tracé 168" d="M31.157,31.157l-6.182-6.182" transform="translate(-5.577 -5.577)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
		</g>
	</svg>

)

export default SvgSearch